class HeaderDrawer extends HTMLElement {
    constructor() {
      super();
      this.toggleDrawer = this.toggleDrawer.bind(this);
      this.handleClickOutside = this.handleClickOutside.bind(this);
    }
  
    connectedCallback() {
      this.toggleButton = document.querySelector('[header-drawer-toggle]');
      this.menuLinks = this.querySelector('#menuLinks');
      this.menuDisclaimer = this.querySelector('#menuDisclaimer');
  
      this.toggleButton.addEventListener('click', this.toggleDrawer);
      document.addEventListener('click', this.handleClickOutside);
    }
  
    disconnectedCallback() {
      this.toggleButton.removeEventListener('click', this.toggleDrawer);
      document.removeEventListener('click', this.handleClickOutside);
    }
  
    toggleDrawer() {
      if (this.classList.contains('drawer-open')) {
        this.playCloseAnimation(() => {
          document.body.style.overflow = 'auto';
          document.body.classList.add('overflow-auto');
          document.body.classList.remove('overflow-hidden');
          this.toggleButton.classList.toggle('header-drawer-closed');
          this.toggleButton.classList.toggle('header-drawer-opened');
          this.classList.toggle('drawer-open');
          this.classList.toggle('drawer-closed');
        });
      } else {
        document.body.style.overflow = 'hidden';
        document.body.classList.add('overflow-hidden');
        document.body.classList.remove('overflow-auto');
        this.playOpenAnimation();
        this.toggleButton.classList.toggle('header-drawer-closed');
        this.toggleButton.classList.toggle('header-drawer-opened');
        this.classList.toggle('drawer-open');
        this.classList.toggle('drawer-closed');
      }
    }

    handleClickOutside(event) {
      if (this.toggleButton.contains(event.target)) {
        this.toggleButton.classList.add('btn-active');
      } else {
        this.toggleButton.classList.remove('btn-active');
      }
    }
  
    playOpenAnimation() {
      const timeline = gsap.timeline();
  
      timeline.fromTo(
        this.menuLinks.children,
        { autoAlpha: 0, scale: 0.8 },
        {
          autoAlpha: 1,
          scale: 1,
          duration: 0.5,
          stagger: 0.1,
          ease: 'back.out(1.7)'
        },
        "+=0.3"
      );
  
      timeline.fromTo(
        this.menuDisclaimer,
        { autoAlpha: 0, scale: 0.8 },
        {
          autoAlpha: 1,
          scale: 1,
          duration: 0.5,
          ease: 'back.out(1.7)'
        },
        "-=0.2" // Starts slightly overlapping with the previous animation
      );
    }
  
    playCloseAnimation(onComplete) {
      const timeline = gsap.timeline({ onComplete });
  
      timeline.fromTo(
        this.menuDisclaimer,
        { autoAlpha: 1, scale: 1 },
        {
          autoAlpha: 0,
          scale: 0.8,
          duration: 0.2,
          ease: 'back.in(1.7)'
        }
      );
  
      timeline.fromTo(
        this.menuLinks.children,
        { autoAlpha: 1, scale: 1 },
        {
          autoAlpha: 0,
          scale: 0.8,
          duration: 0.2,
          stagger: {
            each: 0.1,
            from: "end"
          },
          ease: 'back.in(1.7)'
        },
        "-=0.1"
      );
    }
}
  
window.customElements.define("header-drawer", HeaderDrawer);
  